import type { RadioGroupProps } from '@mui/material/RadioGroup';
import MuiRadioGroup from '@mui/material/RadioGroup';
import { forwardRef } from 'react';

const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>((props, ref) => {
  return <MuiRadioGroup ref={ref} {...props} />;
});

RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;
